import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface CTABlockProps {
  content: {
    headline?: string;
    subtext?: string;
    buttonText?: string;
    buttonLink?: string;
    backgroundImageUrl?: string;
  };
}

export function CTABlock({ content }: CTABlockProps) {
  const hasBg = !!content.backgroundImageUrl;

  return (
    <section className="relative overflow-hidden">
      {hasBg && (
        <>
          <img
            src={content.backgroundImageUrl}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60" />
        </>
      )}
      <div
        className={`relative z-10 mx-auto max-w-[1200px] px-6 py-24 md:py-32 text-center ${
          hasBg ? "" : ""
        }`}
      >
        {content.headline && (
          <h2
            className={`font-serif text-3xl md:text-4xl mb-4 ${
              hasBg ? "text-white" : "text-foreground"
            }`}
          >
            {content.headline}
          </h2>
        )}
        {content.subtext && (
          <p
            className={`font-sans text-sm md:text-base mb-8 max-w-[600px] mx-auto leading-relaxed ${
              hasBg ? "text-white/80" : "text-muted-foreground"
            }`}
          >
            {content.subtext}
          </p>
        )}
        {content.buttonText && (
          <Button
            asChild
            size="lg"
            className={`uppercase tracking-wider text-xs font-sans ${
              hasBg
                ? "bg-white text-black hover:bg-white/90"
                : ""
            }`}
          >
            <Link to={content.buttonLink || "/"}>
              {content.buttonText}
            </Link>
          </Button>
        )}
      </div>
    </section>
  );
}
